import { Component, OnInit } from '@angular/core';
import {ModbusrtuModel} from "../../model/modbusrtu.model";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ModbusService} from "../modbus.service";
import {DeviceAttribute} from "../../model/device-attribute.model";
import {DeviceService} from "../../device/device.service";
import {DeviceType} from "../../model/device-type.model";
import {MeasureModel} from "../../model/measure.model";

@Component({
    selector: 'app-modbusrtu-edit',
    templateUrl: './modbusrtu-edit.component.html',
    standalone: false
})
export class ModbusrtuEditComponent implements OnInit {
  item: ModbusrtuModel;

  types: DeviceType[] = [];
  measures: MeasureModel[] = [];
  attributes: DeviceAttribute[] = [];
  dataTypes :any[] = [];

  constructor(
    private service: ModbusService,
    private deviceService: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.initPage();
    this.getFormData();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/modbusrtu']);
      } else {
        if (id === 'new') {
          this.item = new ModbusrtuModel();
        } else {
          this.fetchItem(id);
        }
      }
    })
  }

  getFormData() {
    this.service.getModbusRTUFormData().subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      if (resp.deviceTypes) {
        this.types = resp.deviceTypes.map(r => new DeviceType(r))
        this.onTypeChange();
      }
      if (resp.measures) {
        this.measures = resp.measures.map(r => new MeasureModel(r));
      }
      if (resp.dataTypes) {
        this.dataTypes = resp.dataTypes;
      }
    })
  }

  onTypeChange() {
    if (!this.types || !this.types.length || !this.item || !this.item.type) {
      return;
    }
    let type:DeviceType = this.types.find(t => t.id === this.item.type);
    this.attributes = [];
    if (type && type.attributes) {
      this.attributes = type.attributes;
    }
  }

  fetchItem(id) {
    this.service.getItem(id).subscribe((resp:any) => {
      if (resp.error) {
        this.service.notiService.open(resp.error);
        this.router.navigate(['/data/modbusrtu']);
      }
      if (resp && resp.id) {
        this.item = new ModbusrtuModel(resp);
        this.onTypeChange();
      }
    })
  }

  saveItem() {
    if (!this.item.type || !this.item.address) {
      return this.service.notiService.open("Type and Address fields are mandatory.");
    }
    this.service.saveItem(this.item).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Saved');
      this.router.navigate(['/data/modbusrtu']);
    })
  }

  onDeleteItemClick() {
    this.service.confirmAction().subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteItem();
      }
    })
  }

  deleteItem() {
    this.service.deleteItem(this.item.id).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open("Deleted");
      this.router.navigate(['/data/modbusrtu']);
    });
  }
}
